import { supabase } from '@/integrations/supabase/client';

export interface CampaignQueueItem {
  id: string;
  recipient_email: string;
  recipient_name: string | null;
  subject: string;
  status: string;
  delivery_status: string | null;
  error_message: string | null;
  sent_at: string | null;
  failed_at: string | null;
  created_at: string;
  attempts: number;
}

export async function fetchCampaignQueueItems(campaignId: string): Promise<CampaignQueueItem[]> {
  const { data, error } = await supabase
    .from('email_queue')
    .select('id, recipient_email, recipient_name, subject, status, delivery_status, error_message, sent_at, failed_at, created_at, attempts')
    .eq('campaign_id', campaignId)
    .order('created_at', { ascending: true });

  if (error) throw error;
  return data || [];
}

export interface CampaignQueuePreview {
  recipient_email: string;
  recipient_name: string | null;
  subject: string;
  html_content: string | null;
  text_content: string | null;
}

export async function fetchCampaignQueuePreviews(campaignId: string): Promise<CampaignQueuePreview[]> {
  const { data, error } = await supabase
    .from('email_queue')
    .select('recipient_email, recipient_name, subject, html_content, text_content')
    .eq('campaign_id', campaignId)
    .order('created_at', { ascending: true })
    .limit(50);

  if (error) throw error;
  return data || [];
}
